/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDining = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h2v8h1V2h2v8h1V2h2v10a4.001 4.001 0 0 1-3 3.874V22H5v-6.126A4.001 4.001 0 0 1 2 12V2zm6 10H4a2 2 0 1 0 4 0zm4-10h10v9a5.002 5.002 0 0 1-4 4.9V20h3v2h-8v-2h3v-4.1a5.002 5.002 0 0 1-4-4.9V2zm2 2v7a3 3 0 0 0 6 0V4h-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDining as Dining };
